<!--
 * @Description: (弹框)分账申请提交成功组件
 * @Author: wanqian
 * @Date: 2023-10-17 08:43:52
-->
<template>
  <el-dialog width="453px" center title="提 示" :visible.sync="visible" :close-on-click-modal="false"
    :before-close="handleCancel" append-to-body class="submit-sharing">
    <div class="submit-sharing-dialog">
      <img style="width: 118px; height: 83px;" src="@/assets/finance/sharinglist/img-finance-sharinglist-apply-success.png" 
        alt="" />
      <div class="text-title">申请成功</div>
      <div class="text-subtitle">{{ sharingSuccessData.tip }}</div>
      <div class="div-sharing-list">
        <div class="div-sharing-list-item" :key="index"
          v-for="(item, index) in sharingSuccessData.revenueSharingItemList">
          <div>{{ item.owner }}</div>
          <div class="div-sharing-list-item-right">
            <div style="margin-left: 25px; display: flex; justify-content: flex-end;">
              <div>实分金额：</div>
              <div style="font-weight: 600; color: #333;">
                {{ item.sharingTotalAmountYuan }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-notes" v-if="sharingSuccessData.remark">
        <span>备注：</span>
        <span style="white-space: pre-line;">
          {{ sharingSuccessData.remark ? sharingSuccessData.remark : '- -' }}
        </span>
      </div>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button type="primary" @click="handleCancel">关 闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SubmitSharing',
  
  props: ["visible", "sharingSuccessData"],
  
  methods:{
    handleCancel() {
      this.$emit("close-dialog");
    }
  }
}
</script>

<style scoped>
.submit-sharing-dialog {
  text-align: center;
}
.submit-sharing-dialog .text-title {
  margin-top: 11px;
  font-size: 16px;
  color: rgba(0,0,0,0.85);
  line-height: 22px;
}
.submit-sharing-dialog .text-subtitle {
  margin-top: 5px;
  padding: 0 33px;
  font-size: 13px;
  color: #666666;
  line-height: 18px;
}
.div-sharing-list {
  margin-top: 10px;
  padding: 0 20px;
}
.div-sharing-list-item {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
}
.div-sharing-list-item-right {
  flex: 1;
  margin-left: 5px;
  display: flex;
  justify-content: flex-end;
}
.submit-sharing-dialog .text-notes {
  margin-top: 20px;
  padding: 14px 20px;
  background: #F7F9FE;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  text-align: left;
}
.dialog-footer {
  margin-top: 50px;
  text-align: center;
}
</style>
<style>
.submit-sharing .el-dialog__body {
  padding: 28px 20px 30px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/components/sharinglist/SubmitSharing.vue